import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import {
  CommonHeader,
  Loader,
  ErrorSuccessModal
} from "../../components/commons";
import { useLocation, useParams } from "react-router-dom";
import {
  PaperClipIcon,
  PlusIconCircle,
  UploadNew,
} from "../../components/Icon";
import { resetSession } from "../../redux/auth";
import { RootState } from "../../redux/rootReducers";
import OtherEntryForm from "../../components/InvoiceGeneration/OtherEntry/OtherEntryForm";
import { GetAllBussinessAddressesListPayloadType, GetAllLedgersListPayloadType } from "../../commonTypes/clientSettingsTypes";
import {
  getAllBusinessAddressAction,
  getAllTypesWithTaxListAction,
} from "../../redux/clientSettings";
import { AllLedgersListType, BusinessAddressListType } from "../../redux/clientSettings/clientSettingTypes";
import toast, { Toaster } from "react-hot-toast";


import {
  AddCommentPayloadType,
  AddOtherInvoiceGenerationPayloadType,
  ApproveInvoicePayloadType,
  GetCommentPayloadType,
  GetAllocationPayloadType,
  GetSingleOtherInvoiceDetailsPayloadType,
  OtherInvoiceGenerationPaymentType,
  UpdateOtherInvoiceGenerationPayloadType
} from "../../commonTypes/invoiceGenerationTypes";
import {
  addOtherInvoiceGenerationAction,
  approveInvoiceAction,
  getInvoiceAllComment,
  getPaymentPendingList,
  getSingleOtherInvoiceDetailsAction,
  postInvoiceAllComment,
  resetApprovalSuccess,
  resetcommentsSuccess,
  resetInvoiceGenerationError,
  resetInvoiceGenerationSuccess,
  resetAllocationList,
  resetSingleOtherInvoiceDetails,
  updateOtherInvoiceGenerationAction,
  getAllAllocationListAction,
  resetAllAllocationList
} from "../../redux/invoiceGeneration";
import { checkSameUserId, formatDate } from "../../utils/commonFunctions";
import { LoginResponseType } from "../../redux/auth/authTypes";
import InvoiceCommentsModal from "../../components/InvoiceGeneration/InvoiveCommentsModal";
import { useMenuCheck } from "../../customHooks/useMenuCheck";
import { downloadLink, imagePreview, renderUploadedFiles } from "../../utils/invoiceGeneration/commonFunctions";
import { ImageDataType } from "../../commonTypes/fileManagerTypes";
import ImagePreview from "../../components/FileManager/Files/ImagePreview";
import RedirectErrorSuccessModal from "../../components/commons/ErrorSuccessModal/RedirectErrorSuccessModal";
import UploadModalWithFileManager from "../../components/InvoiceGeneration/UploadModal/UploadModalWithFileManager";


type TransactionType = {
  value: string;
  label: string;
};

export const TRANSACTION_TYPES: TransactionType[] = [
  {
    value: "debit",
    label: "Sent(Debit)",
  },
  {
    value: "credit",
    label: "Received(Credit)",
  },
];

export type ItemTypes = {
  others_payment_id?: number;
  transaction_type?: Object | null;
  account_details?: object | null;
  amount?: string | null;
  allocated_data?:[]
};

const ITEM_DATA: ItemTypes[] = [
  {
    transaction_type: {},
    account_details: {},
    amount: null,
  },
];

export type OtherErrorType = {
  dateOfInvoiceError: string;
  narrationInBankError: string;
  branchError: string;
};

type AppProps = {
  history?: any;
  token: string | null;
  fetching: boolean;
  success: number | null;
  error: string | null;
  statusCode: number | null;
  allLedgersList: AllLedgersListType[] | [];
  businessAddressList: [] | BusinessAddressListType[];
  singleOtherInvoiceDetails: any;
  fileManagerFetching: boolean;
  currencySign: string | undefined;
  lockedOthersEntriesDate:null | string;
  dispatchResetPaymentPendingListAction:()=>void;
  dispatchResetSessionAction: () => void;
  dispatchGetAllLedgerListAction: (data: GetAllLedgersListPayloadType) => void;
  dispatchAddOtherInvoiceGenerationAction: (
    data: AddOtherInvoiceGenerationPayloadType
  ) => void;
  dispatchUpdateOtherInvoiceGenerationAction: (
    data: UpdateOtherInvoiceGenerationPayloadType
  ) => void;
  dispatchResetInvoiceGenerationError: () => void;
  dispatchResetInvoiceGenerationSuccess: () => void;
  dispatchGetSingleOtherInvoiceDetails: (
    data: GetSingleOtherInvoiceDetailsPayloadType
  ) => void;
  dispatchGetAllBusinessAddressAction: (
    data: GetAllBussinessAddressesListPayloadType
  ) => void;
  dispatchResetSingleOtherInvoiceDetailsAction: () => void;
  loginData: LoginResponseType;
  dispatchApproveInvoice: (data: ApproveInvoicePayloadType) => void;
  approvalSuccess: null | number;
  commentsSuccess: null | number;
  dispatchResetApprovalSuccess: () => void;
  dispatchResetCommentsSuccess: () => void;
  dispatchGetAllInvoiceCommentsAction: (data: GetCommentPayloadType) => void;
  dispatchPostAllInvoiceCommentsAction: (data: AddCommentPayloadType) => void;
  allComments: any;
  dispatchGetPaymentPendingListAction:(data:GetAllocationPayloadType)=>void;
  dispatchResetAllAllocationListAction:()=>void;
  dispatchGetAllAllocationListAction:(data:GetAllocationPayloadType)=>void;
};

type BranchType = {
  value: number | undefined;
  label: string;
}

const CopyOtherEntryInvoice = ({
  history,
  fetching,
  token,
  error,
  success,
  statusCode,
  currencySign,
  allLedgersList,
  businessAddressList,
  fileManagerFetching,
  lockedOthersEntriesDate,
  dispatchResetSessionAction,
  dispatchGetAllLedgerListAction,
  dispatchAddOtherInvoiceGenerationAction,
  dispatchResetSingleOtherInvoiceDetailsAction,
  dispatchResetInvoiceGenerationError,
  dispatchResetInvoiceGenerationSuccess,
  dispatchGetSingleOtherInvoiceDetails,
  dispatchResetAllAllocationListAction,
  singleOtherInvoiceDetails,
  dispatchGetAllBusinessAddressAction,
  loginData,
  dispatchGetAllInvoiceCommentsAction,
  dispatchPostAllInvoiceCommentsAction,
  allComments,
  dispatchResetPaymentPendingListAction,
  dispatchGetPaymentPendingListAction
}: AppProps) => {

  const search = useLocation().search;
	const clientCodeFromParams = new URLSearchParams(search).get('client_code');
	const companyNameFromParams = new URLSearchParams(search).get('company_name');

  const company_name = history?.location?.state?.company_name
    ? history?.location?.state?.company_name
    : companyNameFromParams
  const client_code: number = history?.location?.state?.client_code
    ? history?.location?.state?.client_code
    : clientCodeFromParams
  const editData = singleOtherInvoiceDetails;


  let { invoice_id, id }: any = useParams();
  invoice_id=invoice_id?.includes("?") ? invoice_id?.split("?")[0] : invoice_id;

  let blobBaseUrl = process.env.REACT_APP_BLOB_BASE_URL;
  let blobToken = process.env.REACT_APP_BLOB_TOEKN;

  const [narrationInBank, setNarrationInBank] = useState<string>("");
  const [dateOfInvoice, setDateOfInvoice] = useState<any>();
  const [itemData, setItemData] = useState(
    JSON.parse(JSON.stringify(ITEM_DATA))
  );
  const [totalAmount, setTotalAmount] = useState<number | string | any>(0);
  const [showFileUploadModal, setShowFileUploadModal] =
    useState<boolean>(false);
  const [additionalComments, setAdditionalComments] = useState<string>("");
  const [uploadData, setUploadData] = useState<any[]>([]);
  const [totalAmountError, setTotalAmountError] = useState<boolean>(false);
  const [otherErrors, setOtherErrors] = useState<OtherErrorType>({
    dateOfInvoiceError: "",
    narrationInBankError: "",
    branchError: ""
  });
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [branch, setBranch] = useState<BranchType>({
    label: 'Choose branch name...',
    value: undefined
  })
  const [approved, setApproved] = useState(false);
  const [showInvoiceCommentsModal, setShowInvoiceCommentsModal] = useState<boolean>(false);
  const [invoiceData, setInvoiceData] = useState<any>(null);//comment model data
  const [imageDetails, setImageDetails] = useState<ImageDataType>({
    imageUrl: "",
    downloadImage: "",
    fileType: "",
    finalFileName: "",
    updateBy: "",
    updatedAt: ""
  })
  const [showPopUpContentModal, setShowPopUpContentModal] = useState<boolean>(false)
  const redirection = localStorage.getItem("isRedirected")
  const [isEntryLocked,setIsEntryLocked]=useState(false);
  //============================User Management===========================
  const [isApproveOthersInvoice, setIsApproveOthersInvoice] = useMenuCheck()
  const [isAddOthersInvoiceComments, setIsAddOthersInvoiceComments] = useMenuCheck()
  const [isEditOthersInvoicePresent, setIsEditOthersInvoicePresent] = useMenuCheck();
  const [isAddOthersInvoicePresent, setIsAddOthersInvoicePresent] = useMenuCheck()
  const [isViewOthersInvoicePresent, setIsViewOthersViewInvoicePresent] = useMenuCheck();
  //=============================================================================

  const [auditSeasonMessage,setAuditSeasonMessage] = useState("")


  useEffect(() => {
    setIsEditOthersInvoicePresent("Edit Others Invoicing Advanced", "menu")
    setIsViewOthersViewInvoicePresent("View Other Invoicing Advanced", "menu")
    if (token && id && invoice_id) {
      let finalData: GetSingleOtherInvoiceDetailsPayloadType = {
        client_code: id,
        token,
        other_id: invoice_id,
      };
      setIsAddOthersInvoicePresent("Add Others Invoice", "menu")
      setIsApproveOthersInvoice("Approve Others Invoice", "menu")
      setIsAddOthersInvoiceComments("Add Others Invoice Comments", "menu")
      dispatchGetSingleOtherInvoiceDetails(finalData);
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [invoice_id]);


  useEffect(() => {
    if (editData && Object.keys(editData)?.length > 0) {
       if (editData?.date_of_invoice&&loginData?.user_type===1) {
        let checkDate = editData?.date_of_invoice?.split("-").join(",") <= "2023-03-31"?.split("-").join(",");
         if (!checkDate) {
        setAuditSeasonMessage("")
      }
      else {
        setAuditSeasonMessage("You're entering the invoice of FY 2022-23")
      }
        }
      setIsEdit(true);
      setNarrationInBank(editData?.narration_in_bank);
      setDateOfInvoice(editData?.date_of_invoice);
      setUploadData(editData?.upload);
      setAdditionalComments(editData?.additional_comments);
      setBranch({
        label: editData?.branch_details?.trade_name,
        value: editData?.branch_details?.ledger_id
      });

      let arr: ItemTypes[] = [];

      if (editData?.payment?.length > 0) {
        editData?.payment?.map((data: any) => {
          arr.push({
            transaction_type: {
              value: data?.transaction_type,
              label: TRANSACTION_TYPES.filter(
                (tt: TransactionType) => tt.value === data?.transaction_type
              )[0].label,
            },
            account_details: {
              value: data?.account_details,
              label: data?.account_details?.ledger_name,
            },
            amount: data?.amount?.toString(),
            others_payment_id: data?.others_payment_id,
            allocated_data:data?.allocation_details
          });
        });
      }

      setItemData(arr);
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [editData]);

  useEffect(() => {
    if (loginData?.user_id || singleOtherInvoiceDetails?.approval_details?.length > 0) {
      let user_id
      if (loginData?.user_id) {
        user_id = checkSameUserId(loginData?.user_id, singleOtherInvoiceDetails?.approval_details);
      }
      let totalApprovedData = singleOtherInvoiceDetails?.approval_details?.length === 3;
      setApproved(user_id || totalApprovedData)
    }
  }, [loginData?.user_id, singleOtherInvoiceDetails?.approval_details])

  useEffect(()=>{
    if(dateOfInvoice?.length){
        let splitedInvoiceDate:string[]= formatDate(dateOfInvoice)?.split("-")
        let splitedLockedEntries:string | string[]=lockedOthersEntriesDate ? lockedOthersEntriesDate?.split("-") : "";
        let itemDate =new Date(+splitedInvoiceDate[2],+splitedInvoiceDate[1] - 1,+splitedInvoiceDate[0])
        let lockedDate=new Date(+splitedLockedEntries[2],+splitedLockedEntries[1] - 1,+splitedLockedEntries[0]);
           if(itemDate<=lockedDate){
            setIsEntryLocked(true)
           }
           else{
            setIsEntryLocked(false)
           }
    }
    /* eslint-disable react-hooks/exhaustive-deps */
   },[dateOfInvoice])

  useEffect(() => {
    if (showInvoiceCommentsModal && singleOtherInvoiceDetails) {
      let obj: any = {}
      obj["voucher_invoice_date"] = singleOtherInvoiceDetails?.date_of_invoice;
      obj["branch_details"] = singleOtherInvoiceDetails?.branch_details;

      setInvoiceData(obj)
      if (invoice_id && token && client_code) {
        let finalData: GetCommentPayloadType = {
          type: "others",
          token,
          invoice_id,
          client_code
        }
        dispatchGetAllInvoiceCommentsAction(finalData)
      }

    }

  }, [invoice_id, client_code, showInvoiceCommentsModal, singleOtherInvoiceDetails?.branch_details?.trade_name, singleOtherInvoiceDetails, singleOtherInvoiceDetails?.date_of_invoice, token, dispatchGetAllInvoiceCommentsAction])

  useEffect(() => {
    setApproved(false)
    dispatchResetSingleOtherInvoiceDetailsAction();
    dispatchResetInvoiceGenerationError();
    dispatchResetInvoiceGenerationSuccess();
    if (token && client_code) {
      let finalData = {
        token,
        client_code,
        data_req:"enabled"
      };

      dispatchGetAllLedgerListAction(finalData);
      dispatchGetAllBusinessAddressAction(finalData)
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, []);


  const handleNarrationInBankChange = (e: any) => {
    setNarrationInBank(e.target.value);
    if (otherErrors?.narrationInBankError) {
      setOtherErrors((prevState) => ({
        ...prevState,
        narrationInBankError: "",
      }));
    }
  };

  const handleDateOfInvoiceChange = (date: any) => {
    if (date === "Invalid date") date = "";
    setDateOfInvoice(date);
    if (otherErrors?.dateOfInvoiceError) {
      setOtherErrors((prevState) => ({
        ...prevState,
        dateOfInvoiceError: "",
      }));
    }
    if(loginData?.user_type===1){
      
      let checkDate = date?.split("-").join(",") <= "2023-03-31"?.split("-").join(",");
      if (!checkDate) {
        setAuditSeasonMessage("")
      }
      else if(date!=="") {
        setAuditSeasonMessage("You're entering the invoice of FY 2022-23")
      }
    }
  };


  const validateSubmitData = () => {
    for (let data in itemData) {
      if (
        itemData[data]?.amount === null ||
        !itemData[data]?.amount?.toString().length ||
        !itemData[data]?.transaction_type.hasOwnProperty("value") ||
        !itemData[data]?.account_details.hasOwnProperty("value")
      ) {
        return false;
      }
    }

    return true;
  };

  const handleAddEditOtherEntryData = () => {
    const isValidated = validateSubmitData();
    if (!isValidated) {
      toast.error("Please fill all the mandatory values", {
        duration: 3500,
      });
    } else if (totalAmount !== 0) {
      setTotalAmountError(true);
      toast.error("Total amount should always be 0", {
        duration: 3500,
      });
    } 
    else if (!dateOfInvoice?.length || branch?.value === undefined) {
      setOtherErrors((prevState) => ({
        ...prevState,
        ...(!dateOfInvoice?.length && {
          dateOfInvoiceError: "Required",
        }),
        ...(branch?.value === undefined && {
          branchError: "Please choose branch name",
        })
      }));
    } else {
      setTotalAmountError(false);
   
          
        let finalpaymentData: OtherInvoiceGenerationPaymentType[] = [];
        itemData?.map((item: any) => {
          finalpaymentData.push({
            transaction_type: item?.transaction_type?.value,
            account_details: item?.account_details?.value,
            amount: item?.amount,
          });
        });

        let finalData = {
          token,
          client_code,
          branchDetails: {
            tradeName: branch?.label,
            ledgerId: branch?.value
          },
          date_of_invoice: formatDate(dateOfInvoice),
          narration_in_bank: narrationInBank,
          payment: finalpaymentData,
          additional_comments: additionalComments,
          upload: uploadData,
        };

        dispatchAddOtherInvoiceGenerationAction(finalData);
    //   }
    }
  };

  const getImageDetails = (data: any) => {
    setImageDetails(
      {
        ...data,
        imageUrl: blobBaseUrl + data.file_url + '?' + blobToken,
        downloadImage: data.file_url,
        fileType: data.file_type,
        finalFileName: data.file_name
      })
  }


  const resetImageUrl = () => {
    setImageDetails({
      imageUrl: "",
      downloadImage: "",
      fileType: "",
      finalFileName: "",
      updateBy: "",
      updatedAt: ""
    })
  }

  const handleToggleFileUploadModal = () => {
    setShowFileUploadModal(!showFileUploadModal);
  };

  const handleChange = (dataKey: any, value: any, index: number) => {
    let temp = itemData;
    temp[index][dataKey] = value;
    setItemData([...temp]);

    let sum = 0;

    if (dataKey === "amount" && totalAmount === 0 && totalAmountError) {
      setTotalAmountError(false);
    }

    if (dataKey === "amount") {
      itemData?.map((item: any) => {
        if (
          item?.transaction_type &&
          item?.transaction_type?.value === "credit"
        ) {
          sum = sum + +item?.amount;
        } else if (
          item?.transaction_type &&
          item?.transaction_type?.value === "debit"
        ) {
          sum = sum - item?.amount;
        }
      });

      setTotalAmount(sum.toFixed(2));
    }
    if (dataKey === "transaction_type") {
      itemData?.map((item: any) => {
        if (
          item?.transaction_type &&
          item?.transaction_type?.value === "credit"
        ) {
          sum = sum + +item?.amount;
        } else if (
          item?.transaction_type &&
          item?.transaction_type?.value === "debit"
        ) {
          sum = sum - item?.amount;
        }
      });

      setTotalAmount(sum.toFixed(2));
    }

    if (sum === 0) {
      setTotalAmountError(false);
    }
  };
  useEffect(() => {
    if (totalAmount == 0) {
      setTotalAmount(0);
    }
  }, [totalAmount]);
  const handleUploadFile = (data: any) => {
    if (!uploadData) {
      setUploadData([...data])
    }
    setShowFileUploadModal(false);
    let oldFileUploadData = [...uploadData,...data];

    let finalData=removeDuplicate(oldFileUploadData)

    setUploadData(Array.from(finalData));
  };

  const renderFilesList = () => {
    const isDelete = true;
    const finalFileList =
      uploadData?.length > 0 &&
      uploadData?.map((data: any, index: number) => {
        let file_type = data.file_url.split(".")
        return ((file_type[file_type.length - 1].toLowerCase() === "png" || file_type[file_type.length - 1].toLowerCase() === "jpg" || file_type[file_type.length - 1].toLowerCase() === "jpeg"
          || file_type[file_type.length - 1].toLowerCase() === "doc" || file_type[file_type.length - 1].toLowerCase() === "docx" || file_type[file_type.length - 1].toLowerCase() === "xls"
          || file_type[file_type.length - 1].toLowerCase() === "xlsx"||
          file_type[file_type.length - 1].toLowerCase() === "pdf") ?
          imagePreview(data, index, getImageDetails, handleEditFileList, setShowPopUpContentModal, isDelete) : downloadLink(data, index, getImageDetails, handleEditFileList, setShowPopUpContentModal, isDelete))
      });

    return finalFileList;
  };



  const resetAllocationList=()=>{
    dispatchResetPaymentPendingListAction();
    dispatchResetAllAllocationListAction();
  }


  const handleEditFileList = (index: number) => {
    const tempFileData = JSON.parse(JSON.stringify(uploadData));

    const isFilePresent = tempFileData?.find((data: any, idx: number) => {
      return idx === index;
    });

    if (!!isFilePresent) {
      let newData = tempFileData?.filter(
        (data: any, idx: number) => idx !== index
      );
      setUploadData(newData);
    }
  };



  const handleRemoveRow = (i: number, index: any, dataKey: string) => {
    let temp = [...itemData];
    let oldAmount = temp.find((item: any) => index?.amount === item?.amount);

    let newTotal: any;
    if (oldAmount?.amount === null) {
      temp.splice(i, 1);
      setItemData(temp);
    } else {
      if (dataKey === "credit") {
        newTotal = totalAmount - oldAmount?.amount;
      } else if (dataKey === "debit") {
        newTotal = totalAmount + +oldAmount?.amount;
      }
      temp.splice(i, 1);
      setItemData(temp);
      setTotalAmount(newTotal);
    }
  };

  const removeDuplicate=(data:any)=>{
		let nonRepeatData:any=new Set();

		data?.forEach((obj:any) => (
		   !nonRepeatData.has(JSON.stringify(obj)) && nonRepeatData.add(JSON.stringify(obj))
	   ))

	   let finalData:any = new Set([...nonRepeatData].map(item => JSON.parse(item)))
	   return finalData
	}


	const handleUploadFileFromFileManager=(data:any)=>{
    let finalData:any=removeDuplicate(data)
    setUploadData(Array.from(finalData))
}

  const handleAddRow = () => {
    let temp: any = JSON.parse(JSON.stringify(itemData));
    temp.push(...JSON.parse(JSON.stringify(ITEM_DATA)));
    setItemData(temp);
  };

  const closeTab = () => {
    localStorage.removeItem("isRedirected")
    window.opener = null;
    window.open("", "_self");
    window.close();
  };

  const handleGoBack = () => {
    if (redirection === "yes") {
      closeTab()
    }
  
    dispatchResetSingleOtherInvoiceDetailsAction();

    history?.push({
      pathname: `/invoice-generation/${clientCodeFromParams}#others`,
      state: { client_code: clientCodeFromParams, company_name: companyNameFromParams },
    });

    localStorage.removeItem("client_code");
    localStorage.removeItem("company_name");
  };

  const option: any = businessAddressList?.map((item: any) => {
    return {
      label: item.trade_name,
      value: item.ledger_id
    }
  })

  const handleChangeBranchName = (item: BranchType) => {
    setBranch({
      label: item?.label,
      value: item?.value
    })
    if (item?.value) {
      setOtherErrors((prev: OtherErrorType) => ({
        ...prev,
        branchError: ""
      }))
    }
  }

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSessionAction()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetInvoiceGenerationError();
            }}
          />
        );
      }
    }
   

    if (success === 1) {
      const redirection = localStorage.getItem("isRedirected")
      if (redirection === "yes") {
        return (<RedirectErrorSuccessModal
          type="success"
          isOpen={success === 1}
          title="Success"
          message={"Invoice Updated Successfully!"}
          statusCode={statusCode}
        />)
      } else {
        return (
          <ErrorSuccessModal
            type="success"
            isOpen={success === 1}
            title="Success"
            message={
              isEdit
                ? "Duplicate Invoice Added Successfully!"
                : "Invoice Added Successfully!"
            }
            buttonText="OK"
            onPress={() => {
              dispatchResetInvoiceGenerationSuccess();
              dispatchResetSingleOtherInvoiceDetailsAction();
              setIsEdit(false);
              // localStorage.hasOwnProperty("client_code")
              clientCodeFromParams
                ? handleGoBack()
                : history?.goBack();
            }}
            statusCode={statusCode}
          />
        );
      }
    }

    return false;
  };
  const handleToggleInvoiceCommentsModal = () => {
    setShowInvoiceCommentsModal(!showInvoiceCommentsModal);
  };



  const handleSubmitInvoiceComment = (data: any) => {

    if (token && invoice_id) {
      let finalData: AddCommentPayloadType = {
        client_code,
        token,
        type: "others",
        invoice_id,
        comments: data?.commentText
      };

      dispatchPostAllInvoiceCommentsAction(finalData)
    }
  };

  return (
    <>
      {imageDetails?.imageUrl?.length != 0 && <ImagePreview resetImageUrl={resetImageUrl} imageDetails={imageDetails} />}
      <div className="row">
        <div className="col-md-6 mb-3">
          <CommonHeader
            title={`${isEdit ? "Copy Invoice Details" : "Add Invoice Details"
              }`}
            company_name={company_name}
            client_code={client_code}
          />
        </div>
      </div>
      <div className="content-area">
        <OtherEntryForm
          formType={"duplicateInvoice"}
          allLedgersList={allLedgersList}
          handleNarrationInBankChange={handleNarrationInBankChange}
          handleDateOfInvoiceChange={handleDateOfInvoiceChange}
          narrationInBank={narrationInBank}
          dateOfInvoice={dateOfInvoice}
          itemData={itemData}
          handleChange={handleChange}
          handleRemoveRow={handleRemoveRow}
          totalAmount={totalAmount}
          otherErrors={otherErrors}
          client_code={client_code}
          branch={branch}
          token={token}
          option={option}
          isEdit={isEdit}
          handleChangeBranchName={handleChangeBranchName}
          auditSeasonMessage={auditSeasonMessage}
          currencySign={currencySign}
          resetAllocationList={resetAllocationList}
        />

        <hr />
        <div className="row mt-3">
          <div className="col-6">
            <button className="btn btn-outline btn-sm" onClick={handleAddRow}>
              <span>
                <PlusIconCircle /> Add More
              </span>
            </button>
          </div>
          <div className="col-6">
            <div className="d-flex flex-column">
              <span>
                Total Amount: {currencySign} {totalAmount}
              </span>
              <p
                className={`due-date-text ${totalAmountError ? "text-danger" : ""
                  }`}
              >
                (Note: Total amount should always be equal to 0)
              </p>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <form>
              <div className="form-group">
                <div className="w-75">
                  <label
                    htmlFor="Narration in Bank"
                    className={additionalComments ? "active" : ""}
                  >
                    Additional Comments
                  </label>
                  <input
                    type="text"
                    className={`form-control`}
                    name="narrationInBank"
                    value={additionalComments}
                    onChange={(e) => setAdditionalComments(e.target.value)}
                  />
                </div>
              </div>
            </form>
          </div>
          <div className="col-md-6">
            {!!uploadData?.length && (
              <div className="pointer">
                <span id="Popover1">
                  <PaperClipIcon />
                  <span className="badge count-badge">
                    {uploadData?.length}
                  </span>
                </span>
                {renderUploadedFiles(showPopUpContentModal, setShowPopUpContentModal, renderFilesList)}
              </div>
            )}
            <button
              className="btn btn-sm btn-outline mt-3"
              onClick={handleToggleFileUploadModal}
            >
              <span>
                <UploadNew /> Upload Files
              </span>
            </button>
          </div>
        </div>
      </div>

    

      <div className="row mt-3">
        <div className="col-md-12 text-right">
          <button
            onClick={
                clientCodeFromParams
                ? handleGoBack
                : () => { history?.goBack();
                  dispatchResetSingleOtherInvoiceDetailsAction();
                }
            }
            className="mr-3 btn btn-outline-dark"
          >
          { !isEntryLocked  ?`Cancel`:`Exit`}
          </button>
          {!isEntryLocked  && <button
            className="btn btn-primary"
            onClick={handleAddEditOtherEntryData}
                  >
                      Submit
          </button>}
        </div>
      </div>

      {showFileUploadModal && (
     	<UploadModalWithFileManager
       type={"invoice"}
       isEdit={isEdit}
       isDropZone={true}
       modal={showFileUploadModal}
       toggleModal={handleToggleFileUploadModal}
       client_code={client_code}
       setUploadData={setUploadData}
       uploadData={uploadData}
       token={token}
       setShowFileUploadModal={setShowFileUploadModal}
       handleUploadFile={handleUploadFile}
       handleUploadFileFromFileManager={handleUploadFileFromFileManager}
       fetching={fileManagerFetching}
       isDraggableModal
     />

      )}
      {fetching && <Loader />}
      {handleErrorModal()}
      <Toaster />
      {showInvoiceCommentsModal && <InvoiceCommentsModal
        modal={showInvoiceCommentsModal}
        toggleModal={handleToggleInvoiceCommentsModal}
        data={invoiceData}
        commentList={allComments}
        handlePostComment={handleSubmitInvoiceComment}

      />}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.invoiceGeneration.fetching,
  success: state.invoiceGeneration.success,
  error: state.invoiceGeneration.error,
  statuscode: state.invoiceGeneration.statusCode,
  allLedgersList: state.clientSettings.allTypesLedgersWithTaxList,
  fileManagerFetching: state.fileManager.fetching,
  singleOtherInvoiceDetails: state.invoiceGeneration.singleOtherInvoiceDetails,
  businessAddressList: state.clientSettings.businessAddressList,
  loginData: state.auth.loginData,
  commentsSuccess: state.invoiceGeneration.commentsSuccess,
  approvalSuccess: state.invoiceGeneration.approvalSuccess,
  allComments: state.invoiceGeneration.allComments,
  currencySign:state.auth.currencySign,
  paymentPendingList:state.invoiceGeneration.paymentPendingList,
  allAllocationList:state.invoiceGeneration.allAllocationList,
  lockedOthersEntriesDate:state.invoiceGeneration.lockOthersEntriesDate
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSessionAction: () => dispatch(resetSession()),
  dispatchGetAllLedgerListAction: (data: GetAllLedgersListPayloadType) =>
    dispatch(getAllTypesWithTaxListAction(data)),
  dispatchAddOtherInvoiceGenerationAction: (
    data: AddOtherInvoiceGenerationPayloadType
  ) => dispatch(addOtherInvoiceGenerationAction(data)),
  dispatchUpdateOtherInvoiceGenerationAction: (
    data: UpdateOtherInvoiceGenerationPayloadType
  ) => dispatch(updateOtherInvoiceGenerationAction(data)),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetInvoiceGenerationError: () =>
    dispatch(resetInvoiceGenerationError()),
  dispatchResetInvoiceGenerationSuccess: () =>
    dispatch(resetInvoiceGenerationSuccess()),
  dispatchGetSingleOtherInvoiceDetails: (
    data: GetSingleOtherInvoiceDetailsPayloadType
  ) => dispatch(getSingleOtherInvoiceDetailsAction(data)),
  dispatchResetSingleOtherInvoiceDetailsAction: () =>
    dispatch(resetSingleOtherInvoiceDetails()),
  dispatchGetAllBusinessAddressAction: (data: GetAllBussinessAddressesListPayloadType) =>
    dispatch(getAllBusinessAddressAction(data)),
  dispatchApproveInvoice: (data: ApproveInvoicePayloadType) => dispatch(approveInvoiceAction(data)),
  dispatchResetCommentsSuccess: () => dispatch(resetcommentsSuccess()),
  dispatchGetAllInvoiceCommentsAction: (data: GetCommentPayloadType) => dispatch(getInvoiceAllComment(data)),
  dispatchPostAllInvoiceCommentsAction: (data: AddCommentPayloadType) => dispatch(postInvoiceAllComment(data)),
  dispatchResetApprovalSuccess: () => dispatch(resetApprovalSuccess()),
  dispatchGetPaymentPendingListAction:(data: GetAllocationPayloadType)=> dispatch(getPaymentPendingList(data)),
  dispatchGetAllAllocationListAction:(data: GetAllocationPayloadType)=> dispatch(getAllAllocationListAction(data)),
  dispatchResetPaymentPendingListAction:()=>dispatch(resetAllocationList()),
  dispatchResetAllAllocationListAction:()=>dispatch(resetAllAllocationList())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CopyOtherEntryInvoice);
